module.exports = __webpack_public_path__ + "media/images/plans/proposal-schedule_4-2cc9071704496b498e5e268f27ccaeb3.jpg";